import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableV3CustomsWeightField = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableV3CustomsWeightField);
};
